module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Italian Prince, Wedlocked Wife")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/01.jpg"
    }
  })])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("Welcome to the January 2009 collection of Harlequin Presents!")])]), _c('br'), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("This month be sure to catch the second installment of Lynne Graham’s trilogy VIRGIN BRIDES, ARROGANT HUSBANDS with her new book, "), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Ruthless Magnate’s Virgin Mistress.")])])])]), _vm._v(" Jessica goes from office cleaner to the billionaire boss’s mistress in Sharon Kendrick’s "), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Bought for the Sicilian Billionaire’s Bed,")])])])]), _vm._v(" and sexual attraction simmers uncontrollably when Tara has to face the ruthless count in "), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Count Maxime’s Virgin")])])])]), _vm._v(" by Susan Stephens. You’ll be whisked off to the Mediterranean in Michelle Reid’s "), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Greek’s Forced Bride,")])])])]), _vm._v(" and in Jennie Lucas’s "), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Italian Prince, Wedlocked Wife,")])])])]), _vm._v(" innocent Lucy tries to resist the seductive ways of Prince Maximo. A ruthless tycoon will stop at nothing to bed his convenient wife in Anne McAllister’s "), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Antonides’ Forbidden Wife,")])])])]), _vm._v(" and friends become lovers when playboy Alex Richardson needs a bride in Jennie Lucas’s "), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Italian Prince, Wedlocked Wife.")])])])]), _vm._v(" Plus, in Trish Wylie’s "), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Claimed by the Rogue Billionaire,")])])])]), _vm._v(" attraction reaches the boiling point between Gabe and Ash, but can either of them forget the past?")])]), _c('br'), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("We’d love to hear what you think about Presents. E-mail us at Presents@hmb.co.uk or join in the discussions at www.iheartpresents.com and www.sensationalromance.blogspot.com, where you’ll also find more information about books and authors!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9efb28e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/italianprincewedlockedwife_fm01.vue
// module id = 57
// module chunks = 0